import { createSlice } from "@reduxjs/toolkit";

const initialDepartment = {
  department: "none",
};

const DepartmentsSlice = createSlice({
  name: "Departments",
  initialState: initialDepartment,
  reducers: {
    deactivate(state) {
      state.department = "none";
    },
    Activate(state,action){
        console.log(action.payload)
    }
  },
});

export const DepartmentsActions = DepartmentsSlice.actions;
export default DepartmentsSlice.reducer;
